import _ from "lodash";
import naturalSortFn from "common/filters/natural_sort.pojo";
import DeliverableNotesFilter from "./sb_deliverable_notes_filter.model";

export default function sbDeliverableNotesCtrl(
    $sbIssue,
    $sbDomain,
    EVENTS,
    $rootScope,
    Analytics,
    $scope,
    $mdDialog,
    $log,
    $sbErrorPresenter,
    $sbDeliverableNoteRowMapper,
    $sbDeliverablesNoteStateService
) {
    "ngInject";
    /////////////////////
    //
    //      Direct variables
    //
    /////////////////////

    const vm = this;

    /////////////////////
    //
    //      SCOPE properties
    //
    /////////////////////

    vm.data = undefined;
    vm.groups = [];
    vm.activities = [];
    vm.onStateChange = onStateChange;
    vm.addNoteToListAndSummary = addNoteToListAndSummary;
    vm.onFilterByTeam = onFilterByTeam;
    vm.openCreateNoteDialog = openCreateNoteDialog;
    vm.noteFilter = new DeliverableNotesFilter();
    vm.toggleSummaryFilter = toggleSummaryFilter;

    vm.$onChanges = $onChanges;

    /////////////////////
    //
    //      WATCHER
    //
    /////////////////////

    const noteChangeListener = $rootScope.$on(
        EVENTS.NOTE_CHANGED,
        ($event, changeEvent) => {
            if (!changeEvent.isCreateEvent()) {
                _changeNoteStatusInListAndSummary(changeEvent.after);
            }
        }
    );

    $scope.$on("$destroy", function () {
        noteChangeListener();
    });

    /////////////////////
    //
    //      IMPL
    //
    /////////////////////

    function onStateChange(note, oldValue, newValue) {
        return $sbDeliverablesNoteStateService
            .onStateChange(note, oldValue, newValue)
            .catch($sbErrorPresenter.catch);
    }

    function $onChanges(changes) {
        if (changes.deliverable && vm.deliverable) {
            if (changes.deliverable.previousValue?.id !== vm.deliverable.id) {
                vm.noteFilter = new DeliverableNotesFilter();
            }
            vm.activities = vm.deliverable.getActivities
                ? vm.deliverable.getActivities()
                : [];
        }
        if (changes.selectedTeam || changes.notes || changes.deliverable) {
            if (Array.isArray(vm.notes)) {
                _buildAndSetNoteGroups(vm.selectedTeam);
            }
        }
    }

    function _buildAndSetNoteGroups(filterByTeam) {
        const mappedNotes = vm.notes
            .filter((note) => {
                const filterByTeamId = filterByTeam?.id;
                if (!filterByTeamId) return true;
                if (filterByTeam.isProjectTeam) return true;
                if (
                    note.assigned_team &&
                    note.assigned_team.id === filterByTeamId
                ) {
                    return true;
                }
                if (
                    note.confirmation_team &&
                    note.confirmation_team.id === filterByTeamId
                ) {
                    return true;
                }
                if (!note.assigned_team || note.assigned_team.id === null) {
                    // unassigned case
                    return true;
                }
                return false;
            })
            .map((note) => $sbDeliverableNoteRowMapper.toViewModel(note));

        vm.data = _.sortBy(mappedNotes, ["ISSUE_STATUS", "LAST_UPDATE_TIME"]);

        vm.data.reverse();

        vm.summary = $sbIssue.createIssuesSummary(vm.data);
        vm.summaryLegend = vm.noteFilter.updateSummary(vm.summary);
        _buildNoteGroups();
    }

    function _buildNoteGroups() {
        const notesGroupedByRef = _.groupBy(
            vm.noteFilter.apply(vm.data),
            "REF_COMPONENT_ID"
        );
        const groups = [];
        for (const key in notesGroupedByRef) {
            groups.push({
                id: key,
                name: notesGroupedByRef[key][0].REF_COMPONENT_NAME,
                topologicalIndex:
                    notesGroupedByRef[key][0].REF_COMPONENT_TOPOLOGICAL_INDEX,
                notes: notesGroupedByRef[key],
            });
        }
        vm.groups = groups.sort((a, b) => {
            if (a.topologicalIndex === b.topologicalIndex) {
                return naturalSortFn(a.name, b.name);
            }
            return a.topologicalIndex - b.topologicalIndex;
        });
    }

    function toggleSummaryFilter(issueType) {
        vm.noteFilter.toggle(issueType);
        _buildNoteGroups();
    }

    function addNoteToListAndSummary(note) {
        vm.data = vm.data || [];
        vm.data.unshift(note);
        vm.summary = $sbIssue.createIssuesSummary(vm.data);
        vm.summaryLegend = vm.noteFilter.updateSummary(vm.summary);
        _buildNoteGroups();
        return note;
    }

    function _changeNoteStatusInListAndSummary(note) {
        const noteThatChangedStatus = _.find(vm.data, function (element) {
            return element.ISSUE_ID === note.id;
        });

        if (!noteThatChangedStatus) {
            return;
        }

        noteThatChangedStatus.ISSUE_STATUS = $sbIssue.mapApiToNoteState(
            note.state
        );

        vm.summary = $sbIssue.createIssuesSummary(vm.data);
        vm.summaryLegend = vm.noteFilter.updateSummary(vm.summary);
        _buildNoteGroups();
    }

    function onFilterByTeam(team) {
        if (team.isProjectTeam) {
            Analytics.trackEvent(
                "Details Overlay",
                "click",
                "changed to show all activities"
            );
        } else {
            Analytics.trackEvent(
                "Details Overlay",
                "click",
                "changed to specific team activities"
            );
        }
        vm.onSelectedTeamChange({ team });
    }

    function openCreateNoteDialog($event) {
        if (!vm.deliverable) {
            return;
        }

        if (!Array.isArray(vm.activities) || vm.activities.length === 0) {
            return vm.onCreateNote({ component: vm.deliverable });
        }

        return $mdDialog
            .show(
                $mdDialog
                    .noteTargetSelection({
                        targetEvent: $event,
                        openFrom: $event?.target,
                        closeTo: $event?.target,
                    })
                    .activities(vm.activities)
            )
            .then((selection) => {
                const component = selection || vm.deliverable;
                return vm.onCreateNote({ component });
            })
            .catch((err) => {
                if (err) {
                    throw err;
                }
            });
    }
}
